import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './VerifyPassword.css';

const VerifyPassword: React.FC = () => {
  const [otp, setOtp] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const [isResending, setIsResending] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (otp.length === 6) {
      setShowSuccess(true);
      setTimeout(() => {
        setShowSuccess(false);
      }, 3000);
    }
  };

  const handleOtpChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, ''); // Only allow digits
    if (value.length <= 6) {
      setOtp(value);
    }
  };

  const handleResend = () => {
    setIsResending(true);
    // Mock resend functionality
    setTimeout(() => {
      setIsResending(false);
      setShowSuccess(true);
      setTimeout(() => {
        setShowSuccess(false);
      }, 3000);
    }, 1000);
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="verify-password-container">
      <header className="verify-password-header">
        <button 
          className="back-button" 
          onClick={handleBack}
          aria-label="Go back"
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path 
              d="M10 12L6 8L10 4" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </header>

      <div className="verify-password-content">
        <div className="verify-password-form-wrapper">
          <h1 className="verify-password-title">
            Verify your email/Phone number
          </h1>
          <p className="verify-password-subtitle">
            Enter the 6 digit code sent to <span className="email-highlight">g*******9@muvilo.net</span>
          </p>

          <form onSubmit={handleSubmit} className="verify-password-form">
            <div className="form-group">
              <input
                type="text"
                className="otp-input"
                placeholder="562221"
                value={otp}
                onChange={handleOtpChange}
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength={6}
                required
              />
            </div>

            <div className="otp-resend-section">
              <span className="resend-text">Didn't receive OTP?</span>
              <button
                type="button"
                className="resend-button"
                onClick={handleResend}
                disabled={isResending}
              >
                {isResending ? 'Resending...' : 'Resend'}
              </button>
            </div>
          </form>
        </div>
      </div>

      {showSuccess && (
        <div className="success-notification">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path 
              d="M16.667 5L7.5 14.167L3.333 10" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          </svg>
          <span>Sign Up in successfully!</span>
        </div>
      )}
    </div>
  );
};

export default VerifyPassword;